var React = require('react');

function SiteRouterArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"NAV","transform":"translate(-250.000000, -39.000000)","fill":"#0E141E"},React.createElement("g",{"id":"Group-35","transform":"translate(50.000000, 37.261480)"},React.createElement("g",{"id":"Group-34","transform":"translate(0.000000, 0.738520)"},React.createElement("polygon",{"id":"Fill-11","points":"207.267448 33.3708387 200.87289 26.9703871 202.729823 25.1303226 205.96568 28.3691613 205.96568 1.81625806 208.569215 1.81625806 208.569215 28.3691613 211.785928 25.1494839 213.643442 26.9889677"}))))));
}

SiteRouterArrowInline.defaultProps = {"width":"14px","height":"33px","viewBox":"0 0 14 33"};

module.exports = SiteRouterArrowInline;

SiteRouterArrowInline.default = SiteRouterArrowInline;
